 
            // Initialize the slider
            document.addEventListener('DOMContentLoaded', function() {
                // Initialize Splide
                const splide = new Splide('#prorw-top-product-slider', {
                    type: 'slide',
                    perPage: 5,
                    perMove: 1,
                    // fixedWidth : '18rem',
                    gap: '1rem',
                    pagination: false,
                    arrows: true,
                    autoplay: false,
                    breakpoints: {
                        1024: {
                            perPage: 3, // Desktop: 3 slides (medium screens)
                        },
                        768: {
                            perPage: 3, // Tablet: 3 slides
                            arrows: false,
                        },
                        640: {
                            perPage: 2, // Mobile: 2 slides
                            arrows: false,
                        },
                    },
                });

                splide.mount();
            });


